import { connect } from "react-redux";
import { getCommunications } from "../selectors";
import { signUp } from "../actions/session";
import SignUpForm from "../components/sign-up-form";

function select(state, props) {
  return {
    communications: getCommunications(state, props)
  };
}

export default connect(select, { onSignUp: signUp })(SignUpForm);
